import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import dotRender from '@/helpers/dotRender';
import { areaCodeResp } from '@/utils/areaCode';
import { addClass } from '@/utils/dom';
import { appendDrawer } from '../Drawer';
export var areaCodeTmp = "\n<div sensors-disable=\"true\" class=\"ui-drawer-order\">\n    <div class=\"areacode-content\">\n      <div class=\"drawer-title\">{{=it.t(\"courseSelection.telephonecode.title\")}}</div>\n      <div class=\"ac-box\">\n        <div class=\"list-box\">\n          <div class=\"list-item-title\">{{=it.t(\"courseSelection.telephonecode.commonly\")}}</div>\n          <div class=\"list\">\n            {{~it.common:value}}\n            <div class=\"list-item\">\n              <div class=\"list-item-box\" data-name=\"item\">\n                <span class=\"li-left\" data-areaname={{=value.areaName}}>{{=value.areaName}}</span>\n                <span class=\"li-right\" data-telephonecode={{=value.telephoneCode}}>+{{=value.telephoneCode}}</span>\n              </div>\n            </div>\n            {{~}}\n          </div>\n        </div>\n        <div class=\"list-box\">\n          <div class=\"list-item-title\">{{=it.t(\"courseSelection.telephonecode.other\")}}</div>\n          <div class=\"list\">\n            {{~it.all:value}}\n            <div class=\"list-item\">\n              <div class=\"list-item-box\" data-name=\"item\">\n                <span class=\"li-left\" data-areaname={{=value.areaName}}>{{=value.areaName}}</span>\n                <span class=\"li-right\" data-telephonecode={{=value.telephoneCode}}>+{{=value.telephoneCode}}</span>\n              </div>\n            </div>\n            {{~}}\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n";

var AreaCode = function () {
  function AreaCode(id, ops) {
    this.ops = {
      code: '+86',
      init: true
    };
    this.$code = null;

    if (ops) {
      this.ops = __assign({
        code: '+86',
        init: true
      }, ops);
    }

    this.render(id);
  }

  AreaCode.prototype.render = function (id) {
    var _this = this;

    var box = typeof id === 'string' ? document.getElementById(id.replace(/^#/, '')) : id;

    if (box) {
      var span = document.createElement('span');
      var iItem = document.createElement('i');
      addClass(span, 'national-code');
      addClass(iItem, 'ui-icon ui-icon-down1');
      addClass(box, 'national-box');
      span.innerText = this.ops.code || '+86';
      box.appendChild(span);
      box.appendChild(iItem);
      box.addEventListener('click', function (ev) {
        _this.show();

        var onClick = _this.ops.onClick;

        if (typeof onClick === 'function') {
          onClick(ev);
        }
      }, false);
      this.$code = span;
    }
  };

  AreaCode.prototype.getCode = function () {
    return this.ops.code;
  };

  AreaCode.prototype.show = function () {
    var _this = this;

    var _a = this.ops,
        onClose = _a.onClose,
        onChange = _a.onChange;
    appendDrawer({
      id: 'j-area-code',
      onClose: onClose,
      onMount: function onMount($content) {
        $content.addEventListener('click', function (e) {
          var _a, _b;

          e.stopPropagation();
          var event = e || window.event;
          var target = event.target || event.srcElement; // 判断是否匹配目标元素

          if (target && ((target === null || target === void 0 ? void 0 : target.dataset.name) === 'item' || (target === null || target === void 0 ? void 0 : target.dataset.areaname) || (target === null || target === void 0 ? void 0 : target.dataset.telephonecode))) {
            var rightText = (_b = (_a = target === null || target === void 0 ? void 0 : target.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector('.li-right')) === null || _b === void 0 ? void 0 : _b.innerText;
            _this.ops.code = rightText; // 修改dom

            if (_this.$code) {
              _this.$code.innerHTML = rightText;
            }

            document.body.removeChild($content);

            if (typeof onChange === 'function') {
              onChange(rightText);
            }
          }
        }, false);
      },
      // 渲染支付弹窗结构
      content: dotRender(areaCodeTmp, __assign({}, this.ops.areaCodeData || areaCodeResp))
    });
  };

  return AreaCode;
}();

export default AreaCode;